import React from "react";

const INK = "#1F1A1A";
const SKIN = "#F6C8A2";
const CHEEK = "#F48A97";
const MOUSTACHE = "#5A3020";

const Hat = ({ stroke }) => (
  <>
    <circle cx="46" cy="27" r="15" fill="#FFFFFF" stroke={INK} strokeWidth={stroke} />
    <circle cx="78" cy="27" r="15" fill="#FFFFFF" stroke={INK} strokeWidth={stroke} />
    <circle cx="62" cy="20" r="18" fill="#FFFFFF" stroke={INK} strokeWidth={stroke} />
    <rect x="38" y="34" width="48" height="17" rx="5" fill="#FFFFFF" stroke={INK} strokeWidth={stroke} />
  </>
);

const Face = ({ stroke, blink }) => (
  <>
    <circle cx="62" cy="76" r="30" fill={SKIN} stroke={INK} strokeWidth={stroke} />
    <ellipse className={blink ? "chef-eye" : undefined} cx="52" cy="72" rx="3.2" ry="4.4" fill={INK} />
    <ellipse className={blink ? "chef-eye" : undefined} cx="72" cy="72" rx="3.2" ry="4.4" fill={INK} />
    <circle cx="45" cy="84" r="5" fill={CHEEK} opacity="0.6" />
    <circle cx="79" cy="84" r="5" fill={CHEEK} opacity="0.6" />
    <path d="M49 88 Q55 81 62 87 Q69 81 75 88 Q69 93 62 90 Q55 93 49 88 Z" fill={MOUSTACHE} />
    <path d="M56 95 Q62 101 68 95" fill="none" stroke={INK} strokeWidth="2.2" strokeLinecap="round" />
  </>
);

/** The chef's face in a round frame: the assistant's profile picture. */
export const ChefAvatar = ({ size = 44 }) => (
  <div
    className="flex-none rounded-full bg-primary-50 overflow-hidden flex items-end justify-center"
    style={{ width: size, height: size }}
  >
    <svg width={size * 0.92} height={size * 0.95} viewBox="28 0 68 106" aria-hidden="true">
      <Hat stroke={2.8} />
      <Face stroke={2.8} />
    </svg>
  </div>
);

/** The whole chef, waving: peeks in from the corner of the menu, and rises on the welcome screen. */
export const ChefFigure = ({ width = 140, height = 160, tie = "rgb(var(--brand))" }) => (
  <svg width={width} height={height} viewBox="0 0 120 150" aria-hidden="true">
    <path d="M30 150 L34 114 Q62 100 90 114 L94 150 Z" fill="#FFFFFF" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M50 108 L74 108 L62 124 Z" fill={tie} stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    <circle cx="62" cy="128" r="2.2" fill={INK} />
    <circle cx="62" cy="138" r="2.2" fill={INK} />
    <Face stroke={2.5} blink />
    <Hat stroke={2.5} />
    <g className="chef-hand">
      <path d="M88 118 Q100 108 104 96" fill="none" stroke="#FFFFFF" strokeWidth="12" strokeLinecap="round" />
      <circle cx="105" cy="92" r="9" fill={SKIN} stroke={INK} strokeWidth="2.5" />
    </g>
  </svg>
);
